import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  useMediaQuery
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router";
import { LogoGGT } from "../../components";

const PartnerRedirect = ({ partner, to }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const largeScreen = useMediaQuery(theme => theme.breakpoints.up("md"));

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!loading) return <Redirect to={to} />;

  return (
    <Container maxWidth="sm">
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        style={{ minHeight: "100vh" }}
      >
        <Grid item>
          <Card variant="outlined">
            <CardContent>
              <Box py={3}>
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  spacing={1}
                  direction={largeScreen ? "row" : "column"}
                >
                  <Grid item>{partner.logo("45px")}</Grid>
                  <Grid item>
                    <Typography component="span" variant="h1">
                      +
                    </Typography>
                  </Grid>
                  <Grid item>
                    <LogoGGT />
                  </Grid>
                </Grid>
              </Box>
              <Box mt={2}>
                <Typography align="center">
                  {t("partner_redirect.disclaimer")}
                </Typography>
              </Box>
              <Box mt={4} textAlign="center">
                <CircularProgress color="primary" />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export { PartnerRedirect };
